import { useEffect, useState } from "react"
import { Navbar, Nav, Button, Container, Dropdown } from "react-bootstrap"
import { Link, useLocation } from "react-router-dom"
import "./Navbar.css"
import React from "react"
import MobileMenu from "MobileNavbar"
import ModalSoporte from "utils/ModalSoporte"
import { useIsMobile } from "utils/Utils"
import ModalDomicilios from "Components/ModalDomicilios"
import { Domicilio } from "Interfaces/Domicilio"
import { useErrorModal } from "Context/ErrorModalContext"
import { useApi } from "ApiHooks"
import { useBlockUI } from "Context/BlockUIContext"
import ModalAyuda from "utils/ModalAyuda"
import { tokenStorage } from "TokenStorage"
import ModalCambiarPassword from "utils/ModalCambiarPassword"

const NewNavbar = ({ storage, cerrarSesion }: any) => {

    const location = useLocation()
    const currentPath = location.pathname
    const isLogin = location?.pathname === "/login"
    const isMobile = useIsMobile()
    const api = useApi()
    const { showBlock, hideBlock } = useBlockUI()
    const { showError } = useErrorModal()
    const [showModalCambiarPassword, setShowModalCambiarPassword] = useState(false)
    const [showModalSoporte, setShowModalSoporte] = useState(false)
    const [showModalAyuda, setShowModalAyuda] = useState(false)
    const [showModalDomicilios, setShowModalDomicilios] = useState(false)
    const [faltaDatoDomicilio, setFaltaDatoDomicilio] = useState(false)
    const [domicilios, setDomicilios] = useState<Domicilio[]>([])
    const declaranteActual = storage.getItem("declaranteSeleccionado")
    const nombreDeclaranteActual = storage.getItem("nombreDeclaranteSeleccionado")
    const usuarioActual = storage.getItem("userName")
    const navItems = [
        { to: "/lotes", label: "Lotes" },
        { to: "/formularioF2441", label: "Formulario F3101/F2241" }
    ]

    const userInitials = usuarioActual?.substring(0, 2).toUpperCase()

    const obtenerDomicilios = async () => {
        setDomicilios([])
        showBlock("Cargando domicilios...")
        try {
            const domicilios = await api.getDomiciliosUsuario()
            setDomicilios(domicilios)

            const domicilio = domicilios?.[0]

            const faltaDato = [
                domicilio?.calle,
                domicilio?.numero,
                domicilio?.codigoPostal,
                domicilio?.telefono,
                domicilio?.provincia,
                domicilio?.localidad
            ].some(v => v == null)

            setFaltaDatoDomicilio(faltaDato)
            if (faltaDato) {
                setShowModalDomicilios(true)
            }
        } catch (error: any) {
            if (!api.isCancel(error)) {
                showError({
                    title: 'Error al cargar datos',
                    message: error?.response?.status === 401 ? 'Se ha vencido el tiempo de la sesión' : error?.response?.data?.message,

                })
            }
        } finally {
            hideBlock()
        }
    }

    useEffect(() => {
        if (!isMobile) {
            obtenerDomicilios()
        }
        //eslint-disable-next-line react-hooks/exhaustive-deps        
    }, [isMobile])

    return (
        <>
            {!isLogin && <Navbar expand="lg" className="custom-navbar sticky-top shadow-lg" variant="dark">
                <Container fluid>
                    <Navbar.Brand
                        as={Link}
                        to="/"
                        className="brand-logo ml-auto ml-lg-0"
                    >
                        <img
                            src="/bank_logo_light.png"
                            style={{ width: '130px' }}
                            alt="BankSA Logo"
                            className="d-inline-block align-top navbar-logo"
                        />
                    </Navbar.Brand>

                    <Navbar.Collapse id="basic-navbar-nav" className="d-none d-lg-flex">
                        <Nav className="me-auto">
                            {declaranteActual && (
                                navItems?.map((navItem: any) => (
                                    <Nav.Link as={Link} to={navItem?.to} active={currentPath === navItem?.to} className="nav-link-custom">
                                        {navItem?.label}
                                    </Nav.Link>
                                ))
                            )}

                            {!isMobile && <Nav.Link as={Link} to="#" onClick={() => setShowModalSoporte(true)} className="nav-link-custom">
                                <i className="fas fa-exchange-alt me-2"></i>
                                Soporte
                            </Nav.Link>}
                            {!isMobile && <Nav.Link as={Link} to="#" onClick={() => setShowModalAyuda(true)} className="nav-link-custom">
                                <i className="fas fa-exchange-alt me-2"></i>
                                Ayuda
                            </Nav.Link>}
                            <Nav.Link as={Link} to="#" >
                                Despachante: <strong>{declaranteActual} - {nombreDeclaranteActual}</strong>
                            </Nav.Link>
                        </Nav>
                    </Navbar.Collapse>
                    <div className="d-flex align-items-center">
                        {declaranteActual && (
                            <div className="user-info d-none d-xl-block text-end me-3">
                                {/* <div className="user-info-line">
                                    <p style={{ fontSize: 15 }}><b> Cliente:</b> {userInfo.nroClienteAlpha}</p>
                                </div> */}
                                {/* <div className="user-info-line">
                                    <p style={{ fontSize: 15 }}> <b>Usuario:</b> {usuarioActual}</p>
                                </div> */}
                            </div>

                        )}

                        {declaranteActual && <MobileMenu userInitials={userInitials} nombreDeclaranteActual={nombreDeclaranteActual} declaranteActual={declaranteActual} navItems={navItems} usuarioActual={usuarioActual} setShowModalCambiarPassword={setShowModalCambiarPassword} setShowModalSoporte={setShowModalSoporte} showModalCambiarPassword={showModalCambiarPassword} cerrarSesion={cerrarSesion} />
                        }
                        {declaranteActual && (
                            <div className="d-none d-md-block">
                                <Dropdown>
                                    <Dropdown.Toggle
                                        variant="link"
                                        className="user-avatar-btn p-0 border-0"
                                        id="user-dropdown"
                                    >
                                        <div className="user-avatar">{userInitials}</div>
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu className="user-dropdown-menu">
                                        <div className="dropdown-header-custom">
                                            <div className="d-flex align-items-center">
                                                <div className="user-avatar-small me-2">{userInitials}</div>
                                                <div>
                                                    <div className="fw-bold">{usuarioActual}</div>
                                                </div>
                                            </div>
                                        </div>


                                        {declaranteActual && (
                                            <>
                                                <div className="px-3 py-2">
                                                    <div className="user-detail-line">
                                                        <i className="fas fa-hashtag me-2"></i>
                                                        Declarante: {declaranteActual}
                                                    </div>
                                                    <div className="user-detail-line">
                                                        <i className="fas fa-building me-2">Usuario: {usuarioActual}</i>
                                                    </div>
                                                    <div className="user-detail-line">
                                                        <i className="fas fa-building me-2">Email usuario: {tokenStorage?.getEmailUsuario()}</i>
                                                    </div>
                                                </div>
                                                <Dropdown.Divider />

                                                <Dropdown.Item as={Link} to="/selectDeclarante">
                                                    <i className="fas fa-exchange-alt me-2"></i>
                                                    Cambiar Declarante
                                                </Dropdown.Item>
                                                <Dropdown.Item as={Button} onClick={() => setShowModalCambiarPassword(true)}>
                                                    <i className="fas fa-exchange-alt me-2"></i>
                                                    Cambiar Contraseña
                                                </Dropdown.Item>
                                                <Dropdown.Item as={Button} onClick={() => setShowModalDomicilios(true)}>
                                                    <i className="fas fa-exchange-alt me-2"></i>
                                                    Editar Domicilios
                                                </Dropdown.Item>
                                            </>
                                        )}
                                        <Dropdown.Divider />
                                        <Dropdown.Item onClick={cerrarSesion} className="text-danger">
                                            <i className="fas fa-sign-out-alt me-2"></i>
                                            Cerrar Sesión
                                        </Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>
                        )}
                    </div>
                </Container>
            </Navbar>}
            <ModalDomicilios
                showModalDomicilios={showModalDomicilios}
                setShowModalDomicilios={setShowModalDomicilios}
                onClose={() => setShowModalDomicilios(false)}
                hiddenSelectButton={true}
                onSelect={(dom) => {
                }}
                obtenerDomicilios={obtenerDomicilios}
                domiciliosData={domicilios}
                faltaDatoDomicilio={faltaDatoDomicilio}
            />
            <ModalSoporte setShowModalSoporte={setShowModalSoporte} showModalSoporte={showModalSoporte} />
            <ModalAyuda showModalAyuda={showModalAyuda} handleCloseModalAyuda={() => setShowModalAyuda(false)} />
            <ModalCambiarPassword setShowModalCambiarPassword={setShowModalCambiarPassword} showModalCambiarPassword={showModalCambiarPassword} />
        </>
    )
}

export default NewNavbar
